/* Uses the installed Swym SDK; never creates a second wishlist or alters consent.
   API references: developers.getswym.com/docs/{added-to-wishlist-event,fetch-list-details}
   and /reference/build-a-custom-wishlist-button-1. */
(() => {
  'use strict';
  const drawer = document.getElementById('BWWishlistDrawer');
  if (!drawer) return;
  const host = drawer.querySelector('[data-bw-drawer-products]');
  const count = drawer.querySelector('[data-bw-drawer-count]');
  const notice = drawer.querySelector('.bw-drawer-notice');
  const noticeText = drawer.querySelector('[data-bw-drawer-notice]');
  const error = drawer.querySelector('[data-bw-drawer-error]');
  const undo = drawer.querySelector('[data-bw-wishlist-undo]');
  let sdk, trigger, clickedAt = 0, latest = null, listId = null, items = [], revision = 0, pending = false;
  const key = p => String(p.empi) + ':' + String(p.epi);
  function setError(message) { error.textContent = message; error.hidden = !message; }
  function productHref(p) {
    try {
      const url = new URL(p.du, location.origin);
      if (url.protocol !== 'https:' || ![location.hostname, drawer.dataset.shopDomain].includes(url.hostname) || !/^\/products\/[^/]+/.test(url.pathname)) return null;
      return url.pathname + url.search;
    } catch (_) { return null; }
  }
  function node(tag, cls, text) {
    const el = document.createElement(tag);
    if (cls) el.className = cls;
    if (text != null) el.textContent = text;
    return el;
  }
  function render() {
    const sorted = items.slice().sort((a,b) => (latest && key(b) === key(latest) ? 1 : 0) - (latest && key(a) === key(latest) ? 1 : 0));
    host.replaceChildren();
    count.textContent = items.length + (items.length === 1 ? ' saved item' : ' saved items');
    sorted.forEach(p => {
      const href = productHref(p);
      const row = node('li','bw-drawer-product');
      if (href) {
        const imageLink = node('a','bw-drawer-image'); imageLink.href = href;
        const img = node('img'); img.alt = String(p.dt || 'Product'); img.loading = 'lazy'; img.width = 96; img.height = 96;
        try { const url = new URL(p.iu,location.origin); if (url.protocol === 'https:') img.src = url.href; } catch (_) {}
        imageLink.append(img); row.append(imageLink);
      }
      const info = node('div','bw-drawer-info');
      if (latest && key(p) === key(latest)) info.append(node('span','bw-just-added','JUST ADDED'));
      info.append(node('h3','',p.dt || 'Saved product'));
      if (Number.isFinite(Number(p.pr))) {
        const price = new Intl.NumberFormat(document.documentElement.lang || 'en-US',{style:'currency',currency:drawer.dataset.currency || 'USD'}).format(Number(p.pr));
        info.append(node('p','bw-drawer-price',price));
      }
      if (href) { const a = node('a','','View product →'); a.href = href; info.append(a); }
      row.append(info);
      const remove = node('button','bw-drawer-remove','×'); remove.type='button'; remove.setAttribute('aria-label','Remove ' + (p.dt || 'product') + ' from wishlist');
      remove.disabled = pending; remove.addEventListener('click',()=>removeItem(p,remove));
      row.append(remove); host.append(row);
      const image = row.querySelector('img');
      if (image) window.BWWishlistImages?.watch(image,{id:p.empi},resolved => {
        row.querySelectorAll('a').forEach(a=>{ a.href=resolved.href; });
      });
    });
    if (!items.length) host.append(node('li','bw-drawer-empty','Your wishlist is empty.'));
    notice.hidden = !latest || !items.some(p=>key(p)===key(latest));
    undo.disabled = pending;
  }
  function load(lid, generation) {
    sdk.fetchListDetails({lid}, response => {
      if (generation !== revision) return;
      const products = response?.items || response?.list?.listcontents;
      if (!Array.isArray(products)) { setError('Saved items could not be loaded. Please open My Wishlist.'); return; }
      listId = lid; items = products; render();
    }, () => { if (generation === revision) setError('Saved items could not be loaded. Please open My Wishlist.'); });
  }
  function refresh(product) {
    const generation = ++revision;
    if (product?.lid || listId) { load(product?.lid || listId,generation); return; }
    sdk.fetchLists({
      callbackFn(lists) {
        if (generation !== revision) return;
        const list = lists.find(l=>(l.listcontents || []).some(p=>key(p)===key(product)));
        if (list) load(list.lid,generation);
        else setError('Please open My Wishlist to view this saved item.');
      },
      errorFn() { if (generation === revision) setError('Saved items could not be loaded. Please open My Wishlist.'); }
    });
  }
  function removeItem(product, control) {
    if (pending || !listId) return;
    pending = true; control.disabled = true; undo.disabled = true; setError('');
    const removedLatest = latest && key(latest) === key(product);
    sdk.deleteFromList(listId,{epi:product.epi,empi:product.empi,du:product.du},()=>{
      pending=false; ++revision;
      items=items.filter(p=>key(p)!==key(product));
      if (removedLatest) latest=null;
      render();
      // Keep focus on a stable control after the removed row disappears.
      drawer.querySelector('.bw-drawer-view').focus();
      if (typeof sdk.initializeActionButtons === 'function') sdk.initializeActionButtons(document.getElementById('product-grid') ? '#product-grid' : '#MainContent');
    },()=>{ pending=false; control.disabled=false; undo.disabled=false; setError('This item could not be removed. Please try again.'); });
  }
  document.addEventListener('click',event=>{
    const button = event.target.closest('[data-swaction="addToWishlist"],.swym-add-to-wishlist');
    if (button && !drawer.contains(button)) { trigger=button; clickedAt=Date.now(); }
  },true);
  undo.addEventListener('click',()=>{ if(latest) removeItem(latest,undo); });
  drawer.querySelector('[data-bw-drawer-continue]').addEventListener('click',()=>drawer.hide());
  const desktop = matchMedia('(min-width:1025px)');
  const toast = document.getElementById('BWWishlistToast');
  const toastStatus = document.getElementById('BWWishlistToastStatus');
  let toastTimer, nativeTimer, toastDeadline = 0, toastRemaining = 6000;
  function hideToast() {
    clearTimeout(toastTimer);
    if (toast) {
      const focused = toast.contains(document.activeElement);
      toast.hidden = true;
      if (focused && trigger?.isConnected && typeof trigger.focus === 'function') trigger.focus();
    }
  }
  function pauseToast() { clearTimeout(toastTimer); toastRemaining = Math.max(0, toastDeadline - Date.now()); }
  function resumeToast() {
    if (!toast || toast.hidden || document.hidden || toast.contains(document.activeElement) || toast.matches(':hover')) return;
    clearTimeout(toastTimer); toastDeadline = Date.now() + toastRemaining;
    toastTimer = setTimeout(hideToast, toastRemaining);
  }
  function positionToast() {
    if (!toast || toast.hidden) return;
    const header = document.querySelector('.shopify-section-header') || document.querySelector('.header-wrapper');
    const bottom = Math.max(0, header?.getBoundingClientRect().bottom || 0);
    toast.style.setProperty('--bw-toast-top', Math.min(bottom + 12, Math.max(12, innerHeight - toast.offsetHeight - 12)) + 'px');
  }
  function showToast(product) {
    if (!toast || !product.dt) return;
    const img = toast.querySelector('[data-bw-toast-image]');
    img.hidden = true; img.removeAttribute('src');
    try { const url = new URL(product.iu, location.origin); if (product.iu && url.protocol === 'https:') { img.src = url.href; img.hidden = false; } } catch (_) {}
    img.alt = String(product.dt);
    toast.querySelector('[data-bw-toast-title]').textContent = String(product.dt);
    const line = String(String(product.empi) === toast.dataset.productId ? toast.dataset.productLine : (product.bt || '')).trim();
    const lineNode = toast.querySelector('[data-bw-toast-line]'); lineNode.textContent = line; lineNode.hidden = !line;
    toast.hidden = false;
    window.BWWishlistImages?.watch(img,{id:product.empi},null,true);
    toastStatus.textContent = 'Added to wishlist: ' + String(product.dt);
    // Hide only Swym's wishlist notification, never its error notifications.
    document.documentElement.classList.add('bw-mobile-wishlist-card-active');
    clearTimeout(nativeTimer);
    nativeTimer = setTimeout(()=>document.documentElement.classList.remove('bw-mobile-wishlist-card-active'), 9000);
    toastRemaining = 6000; toastDeadline = Date.now() + toastRemaining;
    clearTimeout(toastTimer); toastTimer = setTimeout(hideToast, toastRemaining);
    positionToast();
  }
  if (toast) {
    toast.querySelector('[data-bw-toast-close]').addEventListener('click', hideToast);
    toast.addEventListener('pointerenter', pauseToast);
    toast.addEventListener('pointerleave', resumeToast);
    toast.addEventListener('focusin', pauseToast);
    toast.addEventListener('focusout', ()=>setTimeout(resumeToast,0));
    toast.addEventListener('keydown', event=>{ if(event.key==='Escape') hideToast(); });
    window.addEventListener('resize', positionToast, {passive:true});
    document.addEventListener('visibilitychange',()=>document.hidden ? pauseToast() : resumeToast());
    desktop.addEventListener('change',positionToast);
  }
  desktop.addEventListener('change',()=>{ if(!desktop.matches && drawer.hasAttribute('open')) drawer.hide(); });
  function ready(swat) {
    if (sdk || !swat.evtLayer || typeof swat.fetchListDetails !== 'function' || typeof swat.deleteFromList !== 'function') return;
    sdk=swat;
    // Theme-local only: keep Swym's native toast, focus/hover pause and View List
    // action. Its installed UI uses settings.UI.NotificationDuration (3s default).
    // Double the mobile duration without changing the app's account-wide settings.
    const configuredDuration = Number(sdk.retailerSettings?.UI?.NotificationDuration);
    const originalDuration = configuredDuration > 0 ? configuredDuration : 3000;
    const updateNotificationDuration = () => {
      // Swym 7 exposes the rendered React UI through ui.uiRef. Cover both
      // pre-render configuration and an already-mounted / remounted UI.
      [sdk.retailerSettings?.UI, sdk.ui?.uiRef?.settings?.UI].forEach(settings => {
        if (!settings || typeof settings !== 'object') return;
        settings.NotificationDuration = desktop.matches ? originalDuration : originalDuration * 2;
      });
    };
    updateNotificationDuration();
    desktop.addEventListener('change', updateNotificationDuration);
    sdk.evtLayer.addEventListener('sw:renderui', updateNotificationDuration);
    sdk.evtLayer.addEventListener('sw:readyui', updateNotificationDuration);
    sdk.evtLayer.addEventListener('sw:addedtowishlist',event=>{
      const product=event?.detail?.d;
      if (!product || !trigger || Date.now()-clickedAt>15000 || pending) return;
      showToast(product);
      if (!desktop.matches) { clickedAt=0; return; }
      clickedAt=0; latest=product; listId=product.lid || null; items=[]; setError('');
      count.textContent='Loading saved items…'; host.replaceChildren(); notice.hidden=false; noticeText.textContent='Added to your wishlist'; undo.disabled=true;
      drawer.show(trigger); refresh(product);
    });
  }
  window.SwymCallbacks=window.SwymCallbacks || [];
  window.SwymCallbacks.push(ready);
})();
